<template>
    <div class="gcmcn-card taker-group-taker">
        <div class="taker-information">
            <div>
                <img :src="taker.logo ? taker.logo : defaultTakerLogo">
            </div>
            <div class="taker-name">
                {{ taker.name}}
            </div>

            <el-popover
                ref="remove-popover"
                placement="bottom"
                width="148"
                trigger="click"
                popper-class="dark-popper"
                @hide="hideSubscribePopover"
            >
                <div>
                    <div class="popover-title">ARE YOU SURE TO REMOVE <b>{{ taker.name }}</b> FROM <b>{{takerGroup.name}}</b> ?</div>
                    <div class="actions">
                        <el-button type="text" class="decline" @click="hideSubscribePopover()">No</el-button>
                        <el-button type="text" class="accept" @click="removeTakerFromGroup()">Yes</el-button>
                    </div>
                </div>
                <el-button
                    slot="reference"
                    type="primary"
                    class="gcmcn-primary-btn small"
                    icon="el-icon-delete"
                ></el-button>
            </el-popover>
        </div>
        <div class="see-more-link" @click="showTaker">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        taker: {
            type: Object,
            required: true,
        },
        takerGroup: {
            type: Object,
            required: true,
        },
    },

    data (){
        return {
            feedConfigured: true,
            defaultTakerLogo: '../../../../static/image/default-taker-logo.png'
        };
    },

    computed: {
    },

    mounted (){

    },

    methods: {
        hideSubscribePopover() {
            if (this.$refs['remove-popover']) {
                this.$refs['remove-popover'].showPopper = false;
            }
        },
        showTaker (){
            this.$router.push({
                name: 'takers',
                params: { takerUid: this.taker.uid}
            });
        },

        removeTakerFromGroup (){
            this.$emit('on-remove-taker-from-group', this.taker);
            this.hideSubscribePopover();
        },
    },
};
</script>

<style lang="scss">
.taker-group-taker{
    & + .taker-group-taker{
        margin-top: 10px;
    }
    .edit-taker{
        display: flex;
        margin-left: auto;
    }
    .taker-information{
        display: flex;
        justify-content: space-between;
        align-items: center;
        img{
            width: 55px;
        }
        .taker-name{
            font-weight: bold;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/RightGroup/taker.vue